module.exports = __webpack_public_path__ + "static/gameon-b6bc1aef0ddff9c8a8601293d6a51cbd.png";